import { EventEmitter } from "@angular/core";

// export class PlansData {
//   title: string;
//   description: {
//     title: string;
//     specialText?: string;
//   };
//   price: string;
//   planId: string;
//   special: boolean;
//   features: string[];
//   commercial?: {
//     planName: string,
//     firstLine: string,
//     secondLine: string
//   }
//   dropdowns: {
//     title: string;
//     description: string;
//     specialText?: string
//   }[]
// }

export class PlansData {
  title: string;
  price: {
    regularPrice: string;
    discountedPrice: string;
  };
  spoId: string;
  displaySequence: number;
  productId: string;
  imageUrl: string;
  catalogDescription: string;
  introText: string;
  displayName: string;
  description: string;
  shortDescription: string;
}

export class BillData {
  accountNumber: string; //"07893451230-00001"
  cartId: string; // "12f15742-45b5-405c-9ad1-c41905e3dcdb"
  currentBill: string; // "211.38"
  mtn: string; // "2488801156"
  newBill: string; // "220.05"
  nextBill: string; // "220.05"
}

export class QuestionsData {
  question: string;
  answer: string;
}

export class UsageData {
  vehicleName: string;
  imei: string;
  usage: {
    wideBand5g: number;
    national5g: number;
    data4g: number;
  }
}

export class IdValidationResponse {
  message?: string;
  success?: boolean;
  aaidInfo?: any;
  statusCode?: number;
  statusDescription?: string;
}

export class IdValidationRequestBody {
  clientID: string;
  redirect_uri: string;
}

export class CodeInputComponentConfig {
  codeLength?: number;
  inputType?: string;
  initialFocusField?: number;
  isCharsCode?: boolean;
  isCodeHidden?: boolean;
  isPrevFocusableAfterClearing?: boolean;
  isFocusingOnLastByClickIfFilled?: boolean;
  code?: string | number;
  disabled?: boolean;
  autocapitalize?: string;
}

export class EventInfo {
  event: string;
  data: any;
}

export class ToastData {
  isOpen: boolean;
  title?: string;
  description?: string;
  buttonText?: any;
  onButtonClick?: any;
  notFadeOut?: boolean;
  success?: boolean;
  error?: boolean;
}

export class SimpleAccordionData {
  title: string;
  description: string;
}

export class CancelVariants {
  label: string;
  formControlName: string | '';
}

export type AuthMode = 'light-sign-in' | 'full-sign-in'
export type SelectPageViewMode = 'select' | 'change';
export type SelectPageContentSections = 'select-plan' | 'review-plan' | 'order-confirm';

export const localStorageDataNames = ['mode', 'payment-plan']

export enum AvailablePopOvers {
  phoneChangeOptions = 'phoneChangeOptions'
}

/*
1) Landing page - set ext_errorcode 1001
2) Account or vehicle is not eligible- 1002
3) confirm TnC decline - 1003
4) TnC declined - 1004
5) something went wrong while subscribing- 1005
6) successful confirmation page - 201
7) phone number was onboarded - 1006
*/
export enum ExternalCode {
  LANDING_PAGE = '1001',
  ACCOUNT_NOT_ELIGIBLE = '1002',
  CONFIRM_TNC_DECLINE = '1003',
  TNC_DECLINED = '1004',
  SUBSCRIPTION_ERROR = '1005',
  SUCCESSFUL_CONFIRMATION = '201',
  INVALID_ACCOUNT = '1006',
  SESSION_EXPIRED = '1007',
  INVALID_PHONE_NUMBER = '1008'
}
